var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManufecturing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_886_15867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3336 9.68153L0.214966 6.14033L10.3618 2.59912L20.0004 6.14033L10.3336 9.68153Z",
    fill: "#1F36C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3329 11.1688L3.96875 8.94165V14.5284L10.0902 16.5714L16.2452 14.5284V9.00299L10.3329 11.1688Z",
    fill: "#1F36C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.213867 13.8906H1.5967V15.4386H0.213867V13.8906Z",
    fill: "#1F36C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.213867 6.19336H1.5967V12.3904H0.213867V6.19336Z",
    fill: "#1F36C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_886_15867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufecturing);
export default __webpack_public_path__ + "static/media/manufecturing.0f089f426a1dd9a74aa81ffeb7d9913f.svg";
export { ForwardRef as ReactComponent };